import { combineReducers, configureStore } from '@reduxjs/toolkit'
import storage from 'localforage'
import { FLUSH, PAUSE, PERSIST, persistReducer, persistStore, PURGE, REGISTER, REHYDRATE } from 'redux-persist'

import application from './application/reducer'
import approvalCache from './approvalCache/reducer'
import burn from './burn/reducer'
import burnV3 from './burn/v3/reducer'
import burnCharm from './charm/burn/reducer'
import mintCharm from './charm/mint/reducer'
import farms from './farms/reducer'
import { updateVersion } from './global/actions'
import burnIsland from './islands/burn/reducer'
import mintIsland from './islands/mint/reducer'
import islandSnapshots from './islandSnapshots/reducer'
import kodiakFarms from './kodiakFarms/reducer'
// import kodiakIslands from './kodiakIslands/reducer'
import kodiakIslands from './kodiakIslands/reducer'
import lists from './lists/reducer'
import mint from './mint/reducer'
import mintV3 from './mint/v3/reducer'
import protocolData from './protocolData/reducer'
import providers from './providers/reducer'
import swap from './swap/reducer'
import tokenPrice from './tokenPrice/reducer'
import transactions from './transactions/reducer'
import user from './user/reducer'
import userPositionData from './userPositionData/reducer'

const rootReducer = combineReducers({
  application,
  user,
  userPositionData,
  transactions,
  swap,
  mint,
  mintV3,
  mintIsland,
  burn,
  burnV3,
  burnIsland,
  mintCharm,
  burnCharm,
  lists,
  farms,
  tokenPrice,
  islandSnapshots,
  protocolData,
  approvalCache,
  // kodiakIslands,
  kodiakFarms,
  kodiakIslands,
  providers,
})

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user', 'transactions', 'lists', 'providers'],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: true,
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})

export const persistor = persistStore(store)

const HARD_RESET = __BUILD_TIME__

;(async () => {
  const currentVersion = localStorage.getItem('HARD_RESET')
  if (currentVersion !== `${HARD_RESET}`) {
    const firstTimeUser = localStorage.getItem('firstTimeUser')

    await persistor.purge()
    localStorage.clear()

    localStorage.setItem('HARD_RESET', `${HARD_RESET}`)
    if (firstTimeUser) {
      localStorage.setItem('firstTimeUser', firstTimeUser)
    }

    // optional: force reload so app starts clean immediately
    window.location.reload()
  }
})()

store.dispatch(updateVersion())

export default store

export type AppState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
